import React, { useEffect, useState } from "react";
import { db } from "../utils/firebase";
import {
  doc,
  updateDoc,
  getDocs,
  collection,
  setDoc,
  getDoc,
} from "firebase/firestore";
import { uuidv4 as uuid } from "@firebase/util";

export default function UserInfoModal({
  user,
  index,
  level,
  id,
  setRole,
  setCommunity,
}) {
  const [communitiesList, setCommunitiesList] = useState([]);

  useEffect(() => {
    async function getCommunities() {
      const q = await getDocs(collection(db, "Communities"));

      setCommunitiesList(
        q.docs.map((doc) => {
          return doc.data();
        })
      );
    }
    getCommunities();
  }, []);

  const roles = [
    { userTypeName: "Admin", userTypeNumber: 4 },
    { userTypeName: "Board Member", userTypeNumber: 3 },
    { userTypeName: "Verified Member", userTypeNumber: 2 },
    { userTypeName: "Non-Verified Member", userTypeNumber: 1 },
  ];

  async function handleChangeCommunity(e) {
    const selectedValue = e.target.value;

    const selectedOptState = communitiesList.filter(
      (d) => d.name == selectedValue
    )[0];

    const docRef = doc(db, "Users", e.target.id);
    await updateDoc(docRef, {
      community: selectedOptState.name,
      communitySlug: selectedOptState.slug,
    });
    setCommunity(selectedOptState.name);
  }

  async function handleChangeRole(e) {
    const selectedValue = e.target.value;

    const selectedOptState = roles.filter(
      (d) => d.userTypeNumber == selectedValue
    )[0];

    const { userTypeName, userTypeNumber } = selectedOptState;

    const docRef = doc(db, "Users", e.target.id);
    await updateDoc(docRef, {
      userTypeName,
      userTypeNumber,
    });
    setRole(userTypeName);
  }

  async function handleApproval(e) {
    e.target.innerHTML = "Approved!";
    const docRef = doc(db, "Users", e.target.id);
    const newMemberEmail = (await getDoc(docRef)).data().email;

    await updateDoc(docRef, {
      userTypeName: "Verified Member",
      userTypeNumber: 2,
    }).then(() => {
      setRole("Verified Member");
    });
    await setDoc(doc(db, "mail", e.target.id + "Approval Email"), {
      to: newMemberEmail,
      message: {
        subject: `You have been approved in ${user.community}`,
        html: ` Hello
          ${user.firstName || "Member"}, you have been approved in ${
          user.community
        }! 👋
        `,
      },
    });
  }

  const availableRoles = roles.filter((roles) => roles.userTypeNumber < level);

  return (
    <div
      key={index}
      className="modal fade"
      id={"exampleModal" + index}
      tabIndex="-1"
      aria-labelledby={"exampleModalLabel" + index}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div
            className="modal-header"
            style={{
              width: "100%",
              color: "#f2a445",
              justifyContent: "center",
            }}
          >
            <h1 className="modal-title fs-5" id={"exampleModalLabel"}>
              User Details
            </h1>
          </div>
          <div
            className="modal-body"
            style={{
              color: "#1d4a22",
            }}
          >
            <div className="container text-center">
              <div className="col">
                <b>Name</b>:{" "}
                {user.name.given_name + " " + user.name.family_name}
              </div>
              <div className="col">
                <b>Email</b>: {user.email_address}
              </div>
              {/* <div className="col">
                <b>Address</b>: {user.address + " " + user.zip}
              </div> */}
              <div className="col">
                <b>Community</b>:{" "}
                <select
                  id={id}
                  defaultValue={user.community}
                  onChange={handleChangeCommunity}
                  style={{
                    margin: "1em auto 0",
                    textAlign: "center",
                  }}
                >
                  <option value={user.community}>{user.community}</option>
                  {communitiesList
                    .filter((community) => community.name != user.community)
                    .map((community) => {
                      return (
                        <option key={community.name} value={community.name}>
                          {community.name}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="col">
                {user.userTypeNumber == 1 ? (
                  <button onClick={handleApproval} id={id}>
                    Approve
                  </button>
                ) : (
                  <>
                    <b>Role</b>:{" "}
                    <select
                      id={id}
                      onChange={handleChangeRole}
                      defaultValue={user.userTypeNumber}
                      style={{
                        margin: "1em auto 0",
                        textAlign: "center",
                      }}
                    >
                      {availableRoles.map((role, i) => {
                        return (
                          <option
                            key={i}
                            style={{ textAlign: "center" }}
                            value={role.userTypeNumber}
                          >
                            {role.userTypeName}
                          </option>
                        );
                      })}
                    </select>
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#f2a445", color: "#1d4a22" }}
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
